import { AxiosResponse } from 'axios';
import { SET_MINYANIM_COUNTDOWNS, SET_MINYANIM_COUNTDOWN, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_MINYANIM_COUNTDOWN_ISLOADING,
  DELETE_MINYANIM_COUNTDOWN,
  EDIT_MINYANIM_COUNTDOWN,
  GET_MINYANIM_COUNTDOWNS,
  REGISTER_MINYANIM_COUNTDOWN,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import MinyanimCountdown from '@/services/minyanim_countdown';
import { Module } from 'vuex';
import { EditMinyanimCountdown, RegisterMinyanimCountdown, GetMinyanimCountdown } from '@/dtos/minyanim_countdown.dto';

const minyanimCountdown: Module<any, {}> = {
  state: {
    minyanimCountdown: {
      data: null,
      isLoading: false,
    },
    minyanimCountdowns: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    minyanimCountdown: (state: { minyanimCountdown: any }) => state.minyanimCountdown,
    minyanimCountdowns: (state: { minyanimCountdowns: any }) => state.minyanimCountdowns,
  },
  mutations: {
    [SET_MINYANIM_COUNTDOWN]: (
      state: { minyanimCountdown: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.minyanimCountdown.data = payload.data) : null,
        (state.minyanimCountdown.isLoading = payload.isLoading);
    },
    [SET_MINYANIM_COUNTDOWNS]: (
      state: { minyanimCountdowns: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.minyanimCountdowns.data = payload.data) : null,
        (state.minyanimCountdowns.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_MINYANIM_COUNTDOWN]: async ({ commit }: any, payload: any) => {
      commit(SET_MINYANIM_COUNTDOWN, { data: null, isLoading: true });

      const result: AxiosResponse = await MinyanimCountdown.registerMinyanimCountdown(
        payload as RegisterMinyanimCountdown
      );

      if (result) {
        if (result.data.status) {
          commit(SET_MINYANIM_COUNTDOWN, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_MINYANIM_COUNTDOWN, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_MINYANIM_COUNTDOWN, { isLoading: false });
        return false;
      }
    },
    [GET_MINYANIM_COUNTDOWNS]: async ({ commit }: any, payload: any) => {
      commit(SET_MINYANIM_COUNTDOWNS, { data: null, isLoading: true });

      const result: AxiosResponse = await MinyanimCountdown.getMinyanimCountdowns(
        payload as GetMinyanimCountdown
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_MINYANIM_COUNTDOWNS, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_MINYANIM_COUNTDOWNS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_MINYANIM_COUNTDOWNS, { isLoading: false });
        return false;
      }
    },
    [EDIT_MINYANIM_COUNTDOWN]: async ({ commit }: any, payload: any) => {
      commit(SET_MINYANIM_COUNTDOWN, { data: null, isLoading: true });

      const result: AxiosResponse = await MinyanimCountdown.editMinyanimCountdown(
        payload as EditMinyanimCountdown
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_MINYANIM_COUNTDOWN, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_MINYANIM_COUNTDOWN, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_MINYANIM_COUNTDOWN, { isLoading: false });
        return false;
      }
    },
    [DELETE_MINYANIM_COUNTDOWN]: async ({ commit }: any, payload: string) => {
      commit(SET_MINYANIM_COUNTDOWN, { data: null, isLoading: true });

      const result: AxiosResponse = await MinyanimCountdown.deleteMinyanimCountdown(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_MINYANIM_COUNTDOWN, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_MINYANIM_COUNTDOWN, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_MINYANIM_COUNTDOWN, { isLoading: false });
        return false;
      }
    },
    [CLEAR_MINYANIM_COUNTDOWN_ISLOADING]: ({ commit }) => {
      commit(SET_MINYANIM_COUNTDOWN, { isLoading: false });
      commit(SET_MINYANIM_COUNTDOWNS, { isLoading: false });
    },
  },
};

export default minyanimCountdown;
